import { configureOpenApiClients } from '../../api/configure';
import { locationGetGoAheadLocations } from '../../api/v2';

export const useLocationApi = () => {
  configureOpenApiClients();

  const getGoAheadLocations = async () => await locationGetGoAheadLocations();

  return {
    getGoAheadLocations,
  };
};
